import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import RemoveIcon from "@mui/icons-material/Remove"; // Unused in the original code
// import AddIcon from "@mui/icons-material/Add"; // Unused in the original code

export default function Accordions({ faqs }) {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div>
      {faqs.map((faq) => (
        <div
          key={faq._id}
          className="mb-3 flex-lg-grow-1"
          style={{ display: "flex", alignItems: "center" }}
        >
          <Accordion
            style={{ width: "100%" }}
            expanded={expanded === faq._id}
            onChange={handleChange(faq._id)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`${faq.id}bh-content`}
              id={`${faq._id}bh-header`}
            >
              <Typography className="w-100">
                <b>{faq.title}</b>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                className="font14px"
                dangerouslySetInnerHTML={{ __html: faq.content }}
              />
            </AccordionDetails>
          </Accordion>
        </div>
      ))}
    </div>
  );
}
